const URL_RE = /(https?:\/\/[^\s،,،؛;)\]"']+)/g;

export function renderMessage(text) {
  const parts = text.split(URL_RE);
  return parts.map((part, i) => {
    if (URL_RE.test(part)) {
      URL_RE.lastIndex = 0;
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="bubble-link"
        >
          {part}
        </a>
      );
    }
    return part;
  });
}
